import { Box, Heading, theme } from "@aksara-ui/react";
import * as React from "react";

export interface DropdownMenuHeaderProps {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const DropdownMenuHeader: React.FC<DropdownMenuHeaderProps> = ({
  className,
  style,
  children,
}) => {
  return (
    <Box
      py="xs"
      px="md"
      backgroundColor={theme.colors.grey01}
      className={className}
      style={style}
    >
      <Heading
        scale={200}
        fontWeight={600}
        lineHeight="16px"
        fontSize={12}
        color="#313F4E"
      >
        {children}
      </Heading>
    </Box>
  );
};

DropdownMenuHeader.displayName = "DropdownMenuItem";

export default DropdownMenuHeader;
